/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon64Regular = forwardRef('ArrowRoundSyncForwardIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M27.12 9.524A23 23 0 0 1 52.2 21h-10.7a1.5 1.5 0 1 0 0 3h12.75A2.75 2.75 0 0 0 57 21.25V8a1.5 1.5 0 0 0-3 0v10.144A26 26 0 0 0 6.047 30.456a1.5 1.5 0 1 0 2.994.178 23 23 0 0 1 18.08-21.11Z" }),
        React.createElement("path", { d: "M22.29 52.85a23 23 0 0 0 32.665-19.407 1.5 1.5 0 1 1 2.994.188 26 26 0 0 1-47.95 12.225V56a1.5 1.5 0 0 1-3 0V42.75A2.75 2.75 0 0 1 9.75 40H22.5a1.5 1.5 0 0 1 0 3H11.802a22.999 22.999 0 0 0 10.489 9.85Z" })));
});
